import React from "react";
import { Button } from "@/components/ui/button";
import { Heading } from "@/components/ui/heading";
import { Text } from "@/components/ui/text";
import Page from "../Page";

interface ServerErrorPageProps {
  error?: Error;
}

const ServerErrorPage: React.FunctionComponent<ServerErrorPageProps> = ({ error }) => {
  return (
    <Page className="flex flex-col items-center justify-center min-h-[calc(100vh-5rem)] text-center px-8">
      <p className="text-8xl font-thin font-display tracking-tight text-muted-foreground/40 mb-4">
        500
      </p>
      <Heading level={1} variant="lg" className="mb-2">
        Something went wrong
      </Heading>
      <Text variant="sm" className="text-muted-foreground mb-8 max-w-sm">
        An unexpected error occurred. Try reloading the page, or go back home.
      </Text>
      {process.env.NODE_ENV === "development" && error && (
        <pre className="text-left text-xs text-destructive bg-destructive/10 rounded-lg p-4 mb-8 max-w-lg w-full overflow-auto">
          {error.message}
          {error.stack && `\n\n${error.stack}`}
        </pre>
      )}
      <div className="flex gap-3">
        <Button variant="outline" onClick={() => window.location.reload()}>
          Reload page
        </Button>
        <Button onClick={() => (window.location.href = "/")}>
          Go home
        </Button>
      </div>
    </Page>
  );
};

export default ServerErrorPage;
